// Toggle imprint/privacy/agb
const showImprint = document.querySelector('a[href^="/#impressum"]')
const imprintContainer = document.getElementById('impressum')
showImprint.addEventListener('click', _ => {
  imprintContainer.classList.add('visible')
  document.querySelector('body').style.overflow = 'hidden' // Prevent body scrolling in the background
})

const showPrivacy = document.querySelector('a[href^="/#datenschutz"]')
const privacyContainer = document.getElementById('datenschutz')
showPrivacy.addEventListener('click', _ => {
  privacyContainer.classList.add('visible')
  document.querySelector('body').style.overflow = 'hidden' // Prevent body scrolling in the background
})

// Because we dont know wheater the element is present
if (document.querySelector('a[href^="/#agb"]') ) {
  const showAgb = document.querySelector('a[href^="/#agb"]')
  const agbContainer = document.getElementById('agb')
  showAgb.addEventListener('click', _ => {
    agbContainer.classList.add('visible')
    document.querySelector('body').style.overflow = 'hidden' // Prevent body scrolling in the background
  })
}
